export function mapObjectKeys<To>(
  from: { [key: string]: unknown },
  map: { [key: string]: string }
): To {
  const mappedFromEntries = Object.entries(from)
    .filter(([key]) => key in map)
    .map(([key, value]) => {
      if (map[key]) {
        return [map[key], value];
      }
      return [key, value];
    });
  return Object.fromEntries(mappedFromEntries);
}
